import { apiRequestInitState } from "../constants";
import {
  SUCCESS_GET_DETAILS,
  FAILURE_GET_DETAILS,
  REQUEST_GET_DETAILS,
  CLEAR_REQUEST_DETAILS,

  REQUEST_DOWNLOAD_FILE_FROM_LIST,
  SUCCESS_DOWNLOAD_FILE_FROM_LIST,
  FAILURE_DOWNLOAD_FILE_FROM_LIST
} from "./actions";


export const requestDetails =(state = apiRequestInitState, action) => {
  switch (action.type) {
    case REQUEST_GET_DETAILS:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_GET_DETAILS:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      };
    case FAILURE_GET_DETAILS:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };
    case CLEAR_REQUEST_DETAILS:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: null
      };
    default:
      return state;
  }
}



